import * as localForage from 'localforage';

import { createStore } from '@ngneat/elf';
import { withActiveId, withActiveIds, withEntities } from '@ngneat/elf-entities';
import {
    createRequestsCacheOperator, createRequestsStatusOperator, initializeAsPending,
    withRequestsCache, withRequestsStatus
} from '@ngneat/elf-requests';
import { persistState } from '@shared/third-party/persist-state/persist-state';

import { Session } from './session.interface';

export const store = createStore(
	{ name: 'session' },
	withEntities<Session, 'company_id'>({ idKey: 'company_id' }),
	withRequestsStatus<`session` | `session-${string}`>(initializeAsPending('session')),
	withRequestsCache<`session` | `session-${string}`>(),
	withActiveId(),
	withActiveIds()
);
export const trackSessionRequestsStatus = createRequestsStatusOperator(store);
export const persist = persistState(store, {
	key: 'session',
	storage: localForage,
});
export const skipWhileSessionCached = createRequestsCacheOperator(store);
